module.exports = __webpack_public_path__ + "img/sign-52.61dc3e42.jpg";